import React, { useState } from "react";
import { useSelector } from "react-redux";

const VideoResources = ({ position = "unset" }) => {
  const [loading, setLoading] = useState(true);

  const selectedRoleName = useSelector(
    (state) => state?.account?.selectedRole?.label
  );

  const filteredVideos = Videos.filter((el) =>
    el.roleName?.includes(selectedRoleName)
  );

  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className=" rounded"
        style={{
          background: "#eeeeee",
          // minHeight: "100vh",
          position: loading ? "unset" : position,
          height: "100vh",
          overflowY: "scroll",
        }}
      >
        {/* <article className="container-fluid">
          <div className="p-3 pb-0  mt-1">
            <h4>Video Resources</h4>
          </div>
        </article> */}
        <article className="container-fluid">
          <section className="bg-white p-5 my-2">
            <h5 className="mt-5">Video Resources</h5>
            <div className="row mt-5">
              {filteredVideos?.map((el, idx) => (
                <div className="col-md-6 col-sm-12 col-lg-4 mb-5" key={idx}>
                  <video
                    width="100%"
                    className="border border-primary"
                    controls
                    playsInline
                    onWaiting={() => setLoading(true)}
                    onCanPlayThrough={() => setLoading(false)}
                    // onTimeUpdate={(e) => {
                    //   const current = e.target.currentTime;
                    //  console.log(current)
                    // }}
                  >
                    <source src={el.src} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                  <h6>{el.title}</h6>
                </div>
              ))}
            </div>
          </section>
        </article>
      </section>
    </div>
  );
};

export default VideoResources;

const Videos = [
  {
    src: "https://objectstorage.us-sanjose-1.oraclecloud.com/p/U-m_5DPCdCHrSusoLM57QBcL5EiS3waDlXl_CCGcsDtWDtndjMyAvonYVWEV67cX/n/axlalvgc2fil/b/knowbase/o/Loanlinq-%20how%20Lender%20Admin%20can%20add%20lender%20accounts.mp4",
    roleName: ["Lender Admin"],
    title: "How Lender Admin can add lender accounts",
    blurTime: { start: 107, end: 109 },
  },
  {
    src: "https://objectstorage.us-sanjose-1.oraclecloud.com/p/U-m_5DPCdCHrSusoLM57QBcL5EiS3waDlXl_CCGcsDtWDtndjMyAvonYVWEV67cX/n/axlalvgc2fil/b/knowbase/o/How%20to%20create%20a%20support%20ticket%20on%20Loanlinq.mp4",
    roleName: [
      "Lender",
      "Broker",
      "Borrower",
      "Lender Admin",
      "Broker Admin",
      "Borrower Admin",
    ],
    title: "How to create a support ticket on Loanlinq",
    blurTime: { start: 5, end: 10 },
  },
  {
    src: "https://objectstorage.us-sanjose-1.oraclecloud.com/p/U-m_5DPCdCHrSusoLM57QBcL5EiS3waDlXl_CCGcsDtWDtndjMyAvonYVWEV67cX/n/axlalvgc2fil/b/knowbase/o/How%20to%20Deactivate%20a%20User%20by%20Lender%20Admin.mp4",
    roleName: ["Lender Admin"],
    title: "How to Deactivate a User in Loanlinq As A Lender Admin",
    blurTime: { start: 5, end: 10 },
  },
  {
    src: "https://objectstorage.us-sanjose-1.oraclecloud.com/p/U-m_5DPCdCHrSusoLM57QBcL5EiS3waDlXl_CCGcsDtWDtndjMyAvonYVWEV67cX/n/axlalvgc2fil/b/knowbase/o/Loanlinq-%20how%20to%20add%20Roles%20to%20your%20Loanlinq%20account.mp4",
    roleName: ["Lender Admin", "Broker Admin"],
    title: "How to Add Roles to your Loanlinq Account",
    blurTime: { start: 5, end: 10 },
  },
  {
    src: "https://objectstorage.us-sanjose-1.oraclecloud.com/p/U-m_5DPCdCHrSusoLM57QBcL5EiS3waDlXl_CCGcsDtWDtndjMyAvonYVWEV67cX/n/axlalvgc2fil/b/knowbase/o/Lender%20Onboarding%20Loanlinq.mp4",
    roleName: ["Broker Admin", "Lender Admin"],
    title: "Lender Onboarding- How to Onboard an Existing Lender on Loanlinq",
    blurTime: { start: 5, end: 10 },
  },
];
